/* Radiant Cosmetics homepage interactions */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* hero pen: tap to shine */
  var st = document.getElementById('stage');
  if (st) {
    var pimg = st.querySelector('img');
    if (pimg) st.style.setProperty('--pm', 'url(' + pimg.src + ')');
    st.addEventListener('click', function () {
      st.classList.remove('go'); void st.offsetWidth; st.classList.add('go');
    });
  }

  /* before / after layers */
  document.querySelectorAll('.ly img').forEach(function (im) {
    im.parentNode.style.setProperty('--bg', 'url(' + im.currentSrc + ')');
    im.addEventListener('load', function () { im.parentNode.style.setProperty('--bg', 'url(' + im.currentSrc + ')'); });
  });
  document.querySelectorAll('.cmp').forEach(function (c) {
    var r = c.querySelector('.rng');
    if (r) r.addEventListener('input', function () { c.style.setProperty('--p', r.value); c.classList.add('used'); });
    function go() {
      if (c.classList.contains('shine')) return;
      c.classList.add('shine');
      setTimeout(function () { c.classList.remove('shine'); }, 1200);
    }
    c.addEventListener('mouseenter', go);
    c.addEventListener('touchstart', go, { passive: true });
    c.addEventListener('click', go);
  });

  /* results: dissolve in on scroll */
  (function () {
    var r = document.getElementById('results');
    if (!r) return;
    function go() { r.classList.add('go'); }
    if (!('IntersectionObserver' in window) || reduce) return;
    r.classList.add('dz');
    var o = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { go(); o.disconnect(); } }, { threshold: 0.1 });
    o.observe(r);
    addEventListener('scroll', function f() {
      var b = r.getBoundingClientRect();
      if (b.top < innerHeight * 0.9) { go(); removeEventListener('scroll', f); }
    }, { passive: true });
    setTimeout(go, 6000);
  })();

  /* cart: add to cart + free shipping toast */
  var cc = document.getElementById('cc');
  var toast = document.createElement('div');
  toast.className = 'toast';
  toast.setAttribute('role', 'status');
  toast.innerHTML = '<div id="tmsg"></div><div class="pb"><i id="tbar"></i></div>';
  document.body.appendChild(toast);
  var tm;
  var FREE = 30;
  function showToast(totalDollars) {
    var left = FREE - totalDollars;
    document.getElementById('tmsg').textContent = left > 0
      ? 'added! you are $' + left.toFixed(2) + ' away from free shipping'
      : 'added! you unlocked free shipping';
    document.getElementById('tbar').style.width = Math.min(100, totalDollars / FREE * 100) + '%';
    toast.classList.add('on');
    clearTimeout(tm);
    tm = setTimeout(function () { toast.classList.remove('on'); }, 3200);
  }
  function refreshCart(cb) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cc) cc.textContent = cart.item_count;
        cb && cb(cart);
      });
  }
  document.querySelectorAll('.add').forEach(function (x) {
    x.addEventListener('click', function () {
      var id = x.getAttribute('data-variant');
      if (!id || x.disabled) return;
      x.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          refreshCart(function (cart) { showToast(cart.items_subtotal_price / 100); });
          x.classList.add('ok');
          x.textContent = 'added';
        })
        .catch(function () { x.textContent = 'try again'; })
        .then(function () {
          setTimeout(function () { x.classList.remove('ok'); x.textContent = 'add to cart'; x.disabled = false; }, 1400);
        });
    });
  });

  /* size quiz */
  var ob = document.querySelectorAll('.opt');
  var res = document.getElementById('res');
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  ob.forEach(function (b) {
    b.addEventListener('click', function () {
      var was = b.getAttribute('aria-pressed') === 'true';
      ob.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      if (was) { res.classList.remove('on'); return; }
      b.setAttribute('aria-pressed', 'true');
      res.classList.remove('on');
      setTimeout(function () {
        res.innerHTML = '<div class="rt"><b>' + esc(b.dataset.t || '') + '</b>' + esc(b.dataset.d || '') +
          '</div><a class="rbtn" href="' + esc(b.dataset.u || '#best') + '">' + esc(b.dataset.b || 'shop') + '</a>';
        res.classList.add('on');
      }, 120);
    });
  });

  /* mobile menu */
  (function () {
    var bb = document.getElementById('burger'), mn = document.getElementById('mnav');
    if (!bb || !mn) return;
    function set(o) {
      mn.hidden = !o;
      bb.setAttribute('aria-expanded', o ? 'true' : 'false');
      bb.setAttribute('aria-label', o ? 'close menu' : 'open menu');
    }
    bb.addEventListener('click', function () { set(mn.hidden); });
    mn.addEventListener('click', function (e) { if (e.target.tagName === 'A') set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
    window.addEventListener('resize', function () { if (innerWidth > 1100) set(false); });
  })();

  /* logo handwriting on hover / tap */
  (function () {
    var l = document.querySelector('header .logo');
    var sv = l && l.querySelector('.inkl');
    if (!sv) return;
    var busy = false, t;
    function go() {
      if (busy || reduce) return;
      busy = true;
      sv.classList.remove('go'); void sv.getBoundingClientRect(); sv.classList.add('go');
      clearTimeout(t);
      t = setTimeout(function () { sv.classList.remove('go'); busy = false; }, 3500);
    }
    l.addEventListener('mouseenter', go);
    l.addEventListener('focus', go);
    l.addEventListener('touchstart', go, { passive: true });
    l.addEventListener('click', go);
  })();

  /* scroll reveal */
  (function () {
    var els = [].slice.call(document.querySelectorAll('.rv'));
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      els.forEach(function (e) { io.observe(e); });
    } else {
      els.forEach(function (e) { e.classList.add('in'); });
    }
    function chk() {
      els.forEach(function (e) {
        if (!e.classList.contains('in') && e.getBoundingClientRect().top < innerHeight * 0.95) e.classList.add('in');
      });
    }
    addEventListener('scroll', chk, { passive: true });
    addEventListener('resize', chk);
    setTimeout(chk, 400);
    setTimeout(function () { els.forEach(function (e) { e.classList.add('in'); }); }, 7000);
  })();
})();
